import React from 'react'
import { Button } from '@/components/ui/button'
import Modal from '../../modal'
import WeeklyTimeslots from '../../availability/show'
import store from '../../../state/store'

const dayOrder = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
const dayShort = {monday: 'Mon', tuesday: 'Tue', wednesday: 'Wed', thursday: 'Thu', friday: 'Fri', saturday: 'Sat', sunday: 'Sun'}

class ClientAvailability extends React.Component {

  state = {
    modalOpen: false
  }

  openModal = () => this.setState({modalOpen: true})
  closeModal = () => this.setState({modalOpen: false})

  onSave = (timeslots) => {
    store.emit('enquiry:lesson_plans:availability:update', this.props.enquiry_id, this.props.lesson_plan_id, timeslots)
  }

  buildGroups(times) {
    const daySlots = {}
    times.forEach(t => {
      const day = t.day_of_week.toLowerCase()
      if (!daySlots[day]) daySlots[day] = []
      daySlots[day].push(t.start_time.slice(0, 5) + '–' + t.end_time.slice(0, 5))
    })

    const activeDays = dayOrder.filter(d => daySlots[d] && daySlots[d].length > 0)
    if (activeDays.length === 0) return []

    const groups = []
    let cur = { days: [activeDays[0]], slots: daySlots[activeDays[0]] }
    for (let i = 1; i < activeDays.length; i++) {
      const prev = activeDays[i - 1]
      const curr = activeDays[i]
      const sameSlots = JSON.stringify(daySlots[prev]) === JSON.stringify(daySlots[curr])
      const consecutive = dayOrder.indexOf(curr) === dayOrder.indexOf(prev) + 1
      if (sameSlots && consecutive) {
        cur.days.push(curr)
      } else {
        groups.push(cur)
        cur = { days: [curr], slots: daySlots[curr] }
      }
    }
    groups.push(cur)
    return groups
  }

  render() {
    const times = this.props.availability?.times || []
    const groups = this.buildGroups(times)

    return (
      <div>
        <div onClick={this.openModal} className="cursor-pointer rounded-[10px] border border-[#c6e9d4] bg-[#f0faf4] px-4 py-3">
          <div className="mb-2 text-xs font-semibold text-[#276749]">Client's preferred times</div>
          {groups.length === 0 ? (
            <Button variant="outline" size="sm" className="-ml-px" onClick={this.openModal}>+ Set times</Button>
          ) : (
            groups.map((group, i) => {
              const label = group.days.length > 1
                ? dayShort[group.days[0]] + ' – ' + dayShort[group.days[group.days.length - 1]]
                : dayShort[group.days[0]]
              return (
                <div key={i} className="flex items-start mb-1">
                  <span className="mr-2 inline-flex min-w-[70px] shrink-0 items-center justify-center whitespace-nowrap rounded bg-[#38a169] px-2 py-[2px] text-xs font-semibold text-white">{label}</span>
                  <div className="flex flex-wrap gap-1">
                    {group.slots.map((slot, j) => (
                      <span key={j} className="rounded bg-[#dcf5e7] px-2 py-[2px] text-xs font-medium text-[#276749]">{slot}</span>
                    ))}
                  </div>
                </div>
              )
            })
          )}
        </div>
        {this.state.modalOpen &&
          <Modal title="Edit Client Availability" size="modal-lg" onClose={this.closeModal}>
            <div className="p-6">
              <WeeklyTimeslots
                key={this.props.availability?.updated_at}
                times={times}
                onSaveTimes={this.onSave}
              />
            </div>
          </Modal>
        }
      </div>
    )
  }
}

export default ClientAvailability
